import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { getScreenMaxWidth, getScreenMaxHeight } from '../../utils/bundle.esm3.js';

const openStateStyles = (props) => {
  if (props.opened) {
    return css`
      top: 0;
      left: 0;
    `;
  }
  return css`
    top: -100vh;
    left: -100vw;
  `;
};
const BackdropStyled = styled.div`
  width: ${getScreenMaxWidth()};
  height: ${getScreenMaxHeight()};
  position: fixed;
  z-index: 2;
  ${openStateStyles};
  background-color: ${(props) => transparentize(1 - props.opacity, props.color)};
  content-visibility: auto;
  isolation: isolate;

  .Backdrop {
  }
`;

export { BackdropStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
